import { ReactElement } from 'react'
import HubShopList from '../../../components/Hubs/Shops'
import Layout from '../../../components/layout'

const HubShopPage = (): ReactElement => {
  return (
    <Layout >
      <HubShopList />
    </Layout>
  )
}

export default HubShopPage
